

$(document).ready(function() {
    var sections = new slate.Sections();
    sections.register('product', theme.Product);

    // Common a11y fixes
    slate.a11y.pageLinkFocus($(window.location.hash));

    $('.in-page-link').on('click', function(evt) {
        slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
    });

    // Target tables to make them scrollable
    var tableSelectors = '.rte table';

    slate.rte.wrapTable({
        $tables: $(tableSelectors),
        tableWrapperClass: 'rte__table-wrapper',
    });

    // Target iframes to make them responsive
    var iframeSelectors =
        '.rte iframe[src*="youtube.com/embed"],' +
        '.rte iframe[src*="player.vimeo"]';

    slate.rte.wrapIframe({
        $iframes: $(iframeSelectors),
        iframeWrapperClass: 'rte__video-wrapper'
    });

    // Apply a specific class to the html element for browser support of cookies.
    if (slate.cart.cookiesEnabled()) {
        document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
    }
});

/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

    /**
     * For use when focus shifts to a container rather than a link
     * eg for In-page links, after scroll, focus shifts to content area so that
     * next `tab` is where user expects if focusing a link, just $link.focus();
     *
     * @param {JQuery} $element - The element to be acted upon
     */
    pageLinkFocus: function($element) {
        var focusClass = 'js-focus-hidden';

        $element.first()
            .attr('tabIndex', '-1')
            .focus()
            .addClass(focusClass)
            .one('blur', callback);

        function callback() {
            $element.first()
                .removeClass(focusClass)
                .removeAttr('tabindex');
        }
    },

    /**
     * If there's a hash in the url, focus the appropriate element
     */
    focusHash: function() {
        var hash = window.location.hash;

        // is there a hash in the url? is it an element on the page?
        if (hash && document.getElementById(hash.slice(1))) {
            this.pageLinkFocus($(hash));
        }
    },

    /**
     * When an in-page (url w/hash) link is clicked, focus the appropriate element
     */
    bindInPageLinks: function() {
        $('a[href*=#]').on('click', function(evt) {
            this.pageLinkFocus($(evt.currentTarget.hash));
        }.bind(this));
    },

    /**
     * Traps the focus in a particular container
     *
     * @param {object} options - Options to be used
     * @param {jQuery} options.$container - Container to trap focus within
     * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
     * @param {string} options.namespace - Namespace used for new focus event handler
     */
    trapFocus: function(options) {
        var eventName = options.namespace
            ? 'focusin.' + options.namespace
            : 'focusin';

        if (!options.$elementToFocus) {
            options.$elementToFocus = options.$container;
        }

        options.$container.attr('tabindex', '-1');
        options.$elementToFocus.focus();

        $(document).on(eventName, function(evt) {
            if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
                options.$container.focus();
            }
        });
    },

    /**
     * Removes the trap of focus in a particular container
     *
     * @param {object} options - Options to be used
     * @param {jQuery} options.$container - Container to trap focus within
     * @param {string} options.namespace - Namespace used for new focus event handler
     */
    removeTrapFocus: function(options) {
        var eventName = options.namespace
            ? 'focusin.' + options.namespace
            : 'focusin';

        if (options.$container && options.$container.length) {
            options.$container.removeAttr('tabindex');
        }

        $(document).off(eventName);
    }
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {

    /**
     * Browser cookies are required to use the cart. This function checks if
     * cookies are enabled in the browser.
     */
    cookiesEnabled: function() {
        var cookieEnabled = navigator.cookieEnabled;

        if (!cookieEnabled){
            document.cookie = 'testcookie';
            cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
        }
        return cookieEnabled;
    }





};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

    /**
     * Return an object from an array of objects that matches the provided key and value
     *
     * @param {array} array - Array of objects
     * @param {string} key - Key to match the value against
     * @param {string} value - Value to get match of
     */
    findInstance: function(array, key, value) {
        for (var i = 0; i < array.length; i++) {
            if (array[i][key] === value) {
                return array[i];
            }
        }
    },

    /**
     * Remove an object from an array of objects by matching the provided key and value
     *
     * @param {array} array - Array of objects
     * @param {string} key - Key to match the value against
     * @param {string} value - Value to get match of
     */
    removeInstance: function(array, key, value) {
        var i = array.length;
        while(i--) {
            if (array[i][key] === value) {
                array.splice(i, 1);
                break;
            }
        }

        return array;
    },

    /**
     * _.compact from lodash
     * Remove empty/false items from array
     * Source: https://github.com/lodash/lodash/blob/master/compact.js
     *
     * @param {array} array
     */
    compact: function(array) {
        var index = -1;
        var length = array == null ? 0 : array.length;
        var resIndex = 0;
        var result = [];

        while (++index < length) {
            var value = array[index];
            if (value) {
                result[resIndex++] = value;
            }
        }
        return result;
    },

    /**
     * _.defaultTo from lodash
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
     *
     * @param {*} value - Value to check
     * @param {*} defaultValue - Default value
     * @returns {*} - Returns the resolved value
     */
    defaultTo: function(value, defaultValue) {
        return (value == null || value !== value) ? defaultValue : value
    }
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap iframes and tables in div tags to force responsive/scrollable layout.
 *
 * @namespace rte
 */

slate.rte = {
    /**
     * Wrap tables in a container div to make them scrollable when needed
     *
     * @param {object} options - Options to be used
     * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
     * @param {string} options.tableWrapperClass - table wrapper class name
     */
    wrapTable: function(options) {
        var tableWrapperClass = typeof options.tableWrapperClass === "undefined" ? '' : options.tableWrapperClass;

        options.$tables.wrap('<div class="' + tableWrapperClass + '"></div>');
    },

    /**
     * Wrap iframes in a container div to make them responsive
     *
     * @param {object} options - Options to be used
     * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
     * @param {string} options.iframeWrapperClass - class name used on the wrapping div
     */
    wrapIframe: function(options) {
        var iframeWrapperClass = typeof options.iframeWrapperClass === "undefined" ? '' : options.iframeWrapperClass;

        options.$iframes.each(function() {
            // Add wrapper to make video responsive
            $(this).wrap('<div class="' + iframeWrapperClass + '"></div>');

            // Re-set the src attribute on each iframe after page load
            // for Chrome's "incorrect iFrame content on 'back'" bug.
            // https://code.google.com/p/chromium/issues/detail?id=395791
            // Need to specifically target video and admin bar
            this.src = this.src;
        });
    }
};

slate.Sections = function Sections() {
    this.constructors = {};
    this.instances = [];

    $(document)
        .on('shopify:section:load', this._onSectionLoad.bind(this))
        .on('shopify:section:unload', this._onSectionUnload.bind(this))
        .on('shopify:section:select', this._onSelect.bind(this))
        .on('shopify:section:deselect', this._onDeselect.bind(this))
        .on('shopify:section:reorder', this._onReorder.bind(this))
        .on('shopify:block:select', this._onBlockSelect.bind(this))
        .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
    _createInstance: function(container, constructor) {
        var $container = $(container);
        var id = $container.attr('data-section-id');
        var type = $container.attr('data-section-type');

        constructor = constructor || this.constructors[type];

        if (typeof constructor === 'undefined') {
            return;
        }

        var instance = $.extend(new constructor(container), {
            id: id,
            type: type,
            container: container
        });

        this.instances.push(instance);
    },

    _onSectionLoad: function(evt) {
        var container = $('[data-section-id]', evt.target)[0];
        if (container) {
            this._createInstance(container);
        }
    },

    _onSectionUnload: function(evt) {
        var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

        if (!instance) {
            return;
        }

        if (typeof instance.onUnload === 'function') {
            instance.onUnload(evt);
        }

        this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
    },

    _onSelect: function(evt) {
        var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

        if (instance && typeof instance.onSelect === 'function') {
            instance.onSelect(evt);
        }
    },

    _onDeselect: function(evt) {
        var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

        if (instance && typeof instance.onDeselect === 'function') {
            instance.onDeselect(evt);
        }
    },

    _onReorder: function(evt) {
        var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

        if (instance && typeof instance.onReorder === 'function') {
            instance.onReorder(evt);
        }
    },

    _onBlockSelect: function(evt) {
        var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

        if (instance && typeof instance.onBlockSelect === 'function') {
            instance.onBlockSelect(evt);
        }
    },

    _onBlockDeselect: function(evt) {
        var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

        if (instance && typeof instance.onBlockDeselect === 'function') {
            instance.onBlockDeselect(evt);
        }
    },

    register: function(type, constructor) {
        this.constructors[type] = constructor;

        $('[data-section-type=' + type + ']').each(function(index, container) {
            this._createInstance(container, constructor);
        }.bind(this));
    }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function () {
    var moneyFormat = '${{amount}}';

    /**
     * Format money values based on your shop currency settings
     * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
     * or 3.00 dollars
     * @param  {String} format - shop money_format setting
     * @return {String} value - formatted value
     */
    function formatMoney(cents, format) {
        if (typeof cents === 'string') {
            cents = cents.replace('.', '');
        }
        var value = '';
        var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
        var formatString = (format || moneyFormat);

        function formatWithDelimiters(number, precision, thousands, decimal) {
            precision = slate.utils.defaultTo(precision, 2);
            thousands = slate.utils.defaultTo(thousands, ',');
            decimal = slate.utils.defaultTo(decimal, '.');

            if (isNaN(number) || number == null) {
                return 0;
            }

            number = (number / 100.0).toFixed(precision);

            var parts = number.split('.');
            var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
            var centsAmount = parts[1] ? (decimal + parts[1]) : '';

            return dollarsAmount + centsAmount;
        }

        switch (formatString.match(placeholderRegex)[1]) {
            case 'amount':
                value = formatWithDelimiters(cents, 2);
                break;
            case 'amount_no_decimals':
                value = formatWithDelimiters(cents, 0);
                break;
            case 'amount_with_comma_separator':
                value = formatWithDelimiters(cents, 2, '.', ',');
                break;
            case 'amount_no_decimals_with_comma_separator':
                value = formatWithDelimiters(cents, 0, '.', ',');
                break;
        }

        return formatString.replace(placeholderRegex, value);
    }

    return {
        formatMoney: formatMoney
    };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function() {

    /**
     * Preloads an image in memory and uses the browsers cache to store it until needed.
     *
     * @param {Array} images - A list of image urls
     * @param {String} size - A shopify image size attribute
     */

    function preload(images, size) {
        if (typeof images === 'string') {
            images = [images];
        }

        for (var i = 0; i < images.length; i++) {
            var image = images[i];
            this.loadImage(this.getSizedImageUrl(image, size));
        }
    }

    /**
     * Loads and caches an image in the browsers cache.
     * @param {string} path - An image url
     */
    function loadImage(path) {
        new Image().src = path;
    }

    /**
     * Find the Shopify image attribute size
     *
     * @param {string} src
     * @returns {null}
     */
    function imageSize(src) {
        var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

        if (match) {
            return match[1];
        } else {
            return null;
        }
    }

    /**
     * Adds a Shopify size attribute to a URL
     *
     * @param src
     * @param size
     * @returns {*}
     */
    function getSizedImageUrl(src, size) {
        if (size === null) {
            return src;
        }

        if (size === 'master') {
            return this.removeProtocol(src);
        }

        var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

        if (match) {
            var prefix = src.split(match[0]);
            var suffix = match[0];

            return this.removeProtocol(prefix[0] + '_' + size + suffix);
        } else {
            return null;
        }
    }

    function removeProtocol(path) {
        return path.replace(/http(s)?:/, '');
    }

    return {
        preload: preload,
        loadImage: loadImage,
        imageSize: imageSize,
        getSizedImageUrl: getSizedImageUrl,
        removeProtocol: removeProtocol
    };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {

    /**
     * Variant constructor
     *
     * @param {object} options - Settings from `product.js`
     */
    function Variants(options) {
        this.$container = options.$container;
        this.product = options.product;
        this.singleOptionSelector = options.singleOptionSelector;
        this.originalSelectorId = options.originalSelectorId;
        this.enableHistoryState = options.enableHistoryState;
        this.currentVariant = this._getVariantFromOptions();

        $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));


        //get varient directly from list
        var _this = this;
        $("[data-vitem-id]").on('click',function(e){
            if(!$(this).hasClass('selected') && !$(this).hasClass('notavailable'))
            {
                $("[data-vitem-id].selected").removeClass('selected');
                $(this).addClass('selected');
                _this._onSelectChangeDirect($(this).attr('data-vitem-id'));
            }
        });
    }

    Variants.prototype = $.extend({}, Variants.prototype, {

        /**
         * Get the currently selected options from add-to-cart form. Works with all
         * form input elements.
         *
         * @return {array} options - Values of currently selected variants
         */
        _getCurrentOptions: function() {
            var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
                var $element = $(element);
                var type = $element.attr('type');
                var currentOption = {};

                if (type === 'radio' || type === 'checkbox') {
                    if ($element[0].checked) {
                        currentOption.value = $element.val();
                        currentOption.index = $element.data('index');

                        return currentOption;
                    } else {
                        return false;
                    }
                } else {
                    currentOption.value = $element.val();
                    currentOption.index = $element.data('index');

                    return currentOption;
                }
            });

            // remove any unchecked input values if using radio buttons or checkboxes
            currentOptions = slate.utils.compact(currentOptions);

            return currentOptions;
        },

        /**
         * Find variant based on selected values.
         *
         * @param  {array} selectedValues - Values of variant inputs
         * @return {object || undefined} found - Variant object from product.variants
         */
        _getVariantFromOptions: function() {
            var selectedValues = this._getCurrentOptions();
            var variants = this.product.variants;
            var found = false;

            variants.forEach(function(variant) {
                var satisfied = true;

                selectedValues.forEach(function(option) {
                    if (satisfied) {
                        satisfied = (option.value === variant[option.index]);
                    }
                });

                if (satisfied) {
                    found = variant;
                }
            });

            return found || null;
        },

        /**
         * Event handler for when a variant input changes.
         */
        _onSelectChange: function() {
            var variant = this._getVariantFromOptions();

            this.$container.trigger({
                type: 'variantChange',
                variant: variant
            });

            if (!variant) {
                return;
            }

            this._updateMasterSelect(variant);
            this._updateImages(variant);
            this._updatePrice(variant);
            this.currentVariant = variant;

            if (this.enableHistoryState) {
                this._updateHistoryState(variant);
            }
            document.querySelector('[name=id]').dispatchEvent(new Event('change'));

        },
        _onSelectChangeDirect: function(th) {

            var variants = this.product.variants;
            var variant = false;

            variants.forEach(function(vari) {

                if(vari.id == th)
                {
                    variant = vari;
                }

            });

            this.$container.trigger({
                type: 'variantChange',
                variant: variant
            });

            if (!variant) {
                return;
            }

            this._updateMasterSelect(variant);
            this._updateImages(variant);
            this._updatePrice(variant);
            this.currentVariant = variant;

            if (this.enableHistoryState) {
                this._updateHistoryState(variant);
            }
            document.querySelector('[name=id]').dispatchEvent(new Event('change'));
        },

        /**
         * Trigger event when variant image changes
         *
         * @param  {object} variant - Currently selected variant
         * @return {event}  variantImageChange
         */
        _updateImages: function(variant) {
            var variantImage = variant.featured_image || {};
            var currentVariantImage = this.currentVariant.featured_image || {};

            if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
                return;
            }

            this.$container.trigger({
                type: 'variantImageChange',
                variant: variant
            });
        },

        /**
         * Trigger event when variant price changes.
         *
         * @param  {object} variant - Currently selected variant
         * @return {event} variantPriceChange
         */
        _updatePrice: function(variant) {
            if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
                return;
            }

            this.$container.trigger({
                type: 'variantPriceChange',
                variant: variant
            });
        },

        /**
         * Update history state for product deeplinking
         *
         * @param {object} variant - Currently selected variant
         */
        _updateHistoryState: function(variant) {
            if (!history.replaceState || !variant) {
                return;
            }

            var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
            window.history.replaceState({path: newurl}, '', newurl);
        },

        /**
         * Update hidden master select of variant change
         *
         * @param {object} variant - Currently selected variant
         */
        _updateMasterSelect: function(variant) {
            $(this.originalSelectorId, this.$container)[0].value = variant.id;
        }
    });

    return Variants;
})();

/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
 * @namespace product
 */

theme.Product = (function() {

    var selectors = {
        addToCart: '[data-add-to-cart]',
        addToCartText: '[data-add-to-cart-text]',
        comparePrice: '[data-compare-price]',
        comparePriceText: '[data-compare-text]',
        originalSelectorId: '[data-product-select]',
        priceWrapper: '[data-price-wrapper]',
        productFeaturedImage: '[data-product-featured-image]',
        productJson: '[data-product-json]',
        productPrice: '[data-product-price]',
        productThumbs: '[data-product-single-thumbnail]',
        singleOptionSelector: '[data-single-option-selector]'
    };

    /**
     * Product section constructor. Runs on page load as well as Theme Editor
     * `section:load` events.
     * @param {string} container - selector for the section container DOM element
     */
    function Product(container) {
        this.$container = $(container);

        // Stop parsing if we don't have the product json script tag when loading
        // section in the Theme Editor
        if (!$(selectors.productJson, this.$container).html()) {
            return;
        }

        var sectionId = this.$container.attr('data-section-id');
        this.productSingleObject = JSON.parse($(selectors.productJson, this.$container).html());

        var options = {
            $container: this.$container,
            enableHistoryState: this.$container.data('enable-history-state') || false,
            singleOptionSelector: selectors.singleOptionSelector,
            originalSelectorId: selectors.originalSelectorId,
            product: this.productSingleObject
        };

        this.settings = {};
        this.namespace = '.product';
        this.variants = new slate.Variants(options);
        this.$featuredImage = $(selectors.productFeaturedImage, this.$container);

        this.$container.on('variantChange' + this.namespace, this.updateAddToCartState.bind(this));
        this.$container.on('variantPriceChange' + this.namespace, this.updateProductPrices.bind(this));

        if (this.$featuredImage.length > 0) {
            this.settings.imageSize = slate.Image.imageSize(this.$featuredImage.attr('src'));
            slate.Image.preload(this.productSingleObject.images, this.settings.imageSize);

            this.$container.on('variantImageChange' + this.namespace, this.updateProductImage.bind(this));
        }
    }


    Product.prototype = $.extend({}, Product.prototype, {

        /**
         * Updates the DOM state of the add to cart button
         *
         * @param {boolean} enabled - Decides whether cart is enabled or disabled
         * @param {string} text - Updates the text notification content of the cart
         */
        updateAddToCartState: function(evt) {
            $('.pre-order-date').hide();
            var variant = evt.variant;
            $('.add-cart .cart-btn').removeClass('noption');

            if (variant) {
                $(selectors.priceWrapper, this.$container).removeClass('hide');
                if( $('.option-eroor').length)
                {
                    $('.option-eroor').slideUp();
                }

            } else {

                $(selectors.addToCart, this.$container).prop('disabled', true);
                $(selectors.addToCartText, this.$container).html(theme.strings.unavailable);
                $(selectors.priceWrapper, this.$container).addClass('hide');

                if($('#shopify-section-product-bundle').length)
                {
                    $('.add-cart .cart-btn').addClass('noption');
                    $(selectors.addToCartText, this.$container).html("Add To Cart");
                }

                return;
            }

            if (variant.available) {
                $(selectors.addToCart, this.$container).prop('disabled', false);
                $(selectors.addToCartText, this.$container).html("Add To Cart");

                if(typeof inv_qty !== 'undefined')
                {
                    if(inv_qty[variant.id] <= 0)
                    {
                        $(selectors.addToCartText, this.$container).html("PREORDER & SAVE");
                        $('.pre-order-date').show();
                    }
                }

            } else {
                $(selectors.addToCart, this.$container).prop('disabled', true);
                $(selectors.addToCartText, this.$container).html(theme.strings.soldOut);
            }
        },

        /**
         * Updates the DOM with specified prices
         *
         * @param {string} productPrice - The current price of the product
         * @param {string} comparePrice - The original price of the product
         */
        updateProductPrices: function(evt) {
            var variant = evt.variant;
            var $comparePrice = $(selectors.comparePrice, this.$container);
            var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);

            $(selectors.productPrice, this.$container)
                .html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));

            if (variant.compare_at_price > variant.price) {
                $comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
                // $compareEls.removeClass('hide');
            } else {
                $comparePrice.html('');
                // $compareEls.addClass('hide');
            }
        },

        /**
         * Updates the DOM with the specified image URL
         *
         * @param {string} src - Image src URL
         */
        updateProductImage: function(evt) {
            var variant = evt.variant;
            // var sizedImgUrl = slate.Image.getSizedImageUrl(variant.featured_image.src, this.settings.imageSize);
            //
            // this.$featuredImage.attr('src', sizedImgUrl);
            if($('[data-img-var="'+variant.id+'"]').length)
            {
                $('[data-img-var="'+variant.id+'"]').trigger('click');
            }
        },

        /**
         * Event callback for Theme Editor `section:unload` event
         */
        onUnload: function() {
            this.$container.off(this.namespace);
        }
    });

    return Product;
})();

/**
 *created By Nalinda - Home page hero banners
 */

"use strict"

var DBL = (typeof DBL === 'object') ? DBL : {};

DBL.hero = {
    VAR: {
        $MainContent: $('#MainContent'),
        winwidth: 0,
        heroWidth: 1920,
        heroHeight: 822,
        maxWidth: 1500
    },
    init: function () {
        var _this = this;

        $('.hero-slider').slick({


            nextArrow: '<div class="hero-next hero-btn"><svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 306 306" style="enable-background:new 0 0 306 306;" xml:space="preserve"><g><g id="chevron-right" style="fill:#FFFFFF"><polygon points="94.35,0 58.65,35.7 175.95,153 58.65,270.3 94.35,306 247.35,153 \t\t"/></g></g></svg></div>',
            prevArrow: '<div class="hero-prev hero-btn"><svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 306 306" style="enable-background:new 0 0 306 306; transform: rotate(180deg);" xml:space="preserve"><g><g id="chevron-right" style="fill:#FFFFFF"><polygon points="94.35,0 58.65,35.7 175.95,153 58.65,270.3 94.35,306 247.35,153 \t\t"/></g></g></svg></div>',


            pauseOnHover: false, slidesToShow: 1, slidesToScroll: 1, dots: true, arrows: false,
            autoplay: true,
            autoplaySpeed: 6000, infinite: true,
            responsive: [
                {
                    breakpoint: 750,
                    settings: {
                        dots: true, arrows: false
                    }
                }
            ]

        });

        $(window).on('uti-width-changed', function () {
            // sizechangehero();
        });

        function sizechangehero()
        {
            var videocontainer = $('.hero-vid');
            var newmp4 = $('.hero-sou').attr('data-m');
            if (UTI.isdesktop)
            {
                newmp4 = $('.hero-sou').attr('data-d');
            }


            var videosource = $('.hero-sou');

            videocontainer.get(0).pause();
            videosource.get(0).setAttribute('src', newmp4);
            videocontainer.get(0).load();
            //videocontainer.setAttribute('poster', newposter); //Changes video poster image
            videocontainer.get(0).play();
        }
        if( $('.hero-sou').length)sizechangehero();



        $('body').on('click','.slider-home .learnmore',function(e){
            e.preventDefault();
            UTI.common.scrollTo('.image-change',20,500);

        });

        $('.mainlink, .hero-slider video').click(function(e){
            e.preventDefault();
            $('.main-nav-wrap a.line').eq(0).trigger('click');

        });
    }

};



/**
 *created By Nalinda - Home page hero banners
 */

"use strict"

var DBL = (typeof DBL === 'object') ? DBL : {};

DBL.scrolls = {
    VAR: {
        once: false
    },
    init: function () {

        if (DBL.scrolls.VAR.once) {
            return;
        }
        DBL.scrolls.VAR.once = true;


        $(window).on('uti-width-changed', function () {
            setTimeout(function(){
                resetpage();
            },100);

        });
        setTimeout(function(){resetpage()},100);

        function resetpage()
        {
            var winhei = $(window).height();
            var winwid = $(window).width();
            var fewimage = $('.hom.fea-col .fe-image');



            var bblock = $('.home-block .b-img');
            var bdec= $('.home-block .b-des');
            var he = bblock.eq(0).width() * (798/1182);
            bblock.height(he);

            if(winwid > 992)
            {
                bdec.height(he+120);
                $('.home-block').height(he+240);
            }
            else
            {
                bdec.height("");
                $('.home-block').height("");
            }








        }




        TweenLite.defaultEase = Linear.easeNone;
        var controller = new ScrollMagic.Controller();


        if(UTI.isdesktop)
        {
            var tl = new TimelineMax();
            tl.fromTo(  $('.image-box .changer.opa').eq(0), 1, { opacity: 0 }, { opacity: 1, ease: Linear.easeNone }, "+=1");
            tl.fromTo(  $('.image-box .changer.opa').eq(1), 1, { opacity: 0 }, { opacity: 1, ease: Linear.easeNone }, "+=1");

            new ScrollMagic.Scene({
                triggerElement: ".image-changer-inside",
                triggerHook: 0.25,
                duration: "20%"
            }).setPin("#pinMaster").setTween(tl).addTo(controller);
            //.addIndicators() ;
        }else
        {

            var tl = new TimelineMax();
            tl.fromTo(
                $('.image-box .changer.opa').eq(0),
                1,
                { opacity: 0 },
                { opacity: 1, ease: Linear.easeNone },
                "+=1"
            );
            tl.fromTo(
                $('.image-box .changer.opa').eq(1),
                1,
                { opacity: 0 },
                { opacity: 1, ease: Linear.easeNone },
                "+=1"
            );

            new ScrollMagic.Scene({
                triggerElement: ".image-changer-inside",
                triggerHook: 0.25,
                duration: "50%"
            }).setPin("#pinMaster").setTween(tl).addTo(controller);

        }



        ////////path animation svg
        function pathPrepare($el) {
            if($el.length)
            {
                var lineLength = $el[0].getTotalLength();
                $el.css("stroke-dasharray", lineLength);
                $el.css("stroke-dashoffset", lineLength);
            }

        }






        //START---------------Home block link scroll effect-------------------------------

        var scenehomeblock = [];
        var thomeblock = [];

        for (var i = 0; i < $(".home-block").length; i++) {

            var npos = $(".home-block").eq(i);
            var nset = npos.find('.b-img');
            var hh = npos.find('h2');
            npos.addClass('home-block' + i);

            var moveleft = "%20";
            if(npos.hasClass("left"))
            {
                moveleft = "-%20";
            }

            thomeblock[i] = new TimelineMax();

            //thomeblock[i].from(hh, 20, {left: '20%', ease: Linear.easeNone}, 2);


            // thomeblock[i].to(nset, 20, {backgroundSize: '120%', ease: Linear.easeNone}, 1);
            thomeblock[i].fromTo(nset, 1, {opacity: 0}, {opacity: 1, ease: Linear.easeNone}, 0); // in from left
            scenehomeblock[i] = new ScrollMagic.Scene({
                triggerElement: ".home-block" + i,
                triggerHook: 0.75
            })
                //.addIndicators({name: "Box Timeline",colorTrigger: "black",colorStart: "black",colorEnd: "black"})
                .setTween(thomeblock[i])
                .addTo(controller);



        }




        //---------------Home block link scroll effect-------------------------------END


        //start------------------sginature section-------------------



        var sigpath = $("path.sig");
        pathPrepare(sigpath);

        // build tween
        var tweensig = new TimelineMax()
            .add(TweenMax.to('.sig.sig1', 0.9, {strokeDashoffset: 0, ease:Linear.easeNone})) // draw word for 0.9
            .add(TweenMax.to('.sig.sig2', 0.2, {strokeDashoffset: 0, ease:Linear.easeNone})) // draw word for 0.9
            .add(TweenMax.to('.sig.sig3', 0.9, {strokeDashoffset: 0, ease:Linear.easeNone})) // draw word for 0.9
            .add(TweenMax.to('.sig.sig3b', 0.9, {strokeDashoffset: 0, ease:Linear.easeNone})) // draw word for 0.9
            .add(TweenMax.to('.sig.sig4', 0.9, {strokeDashoffset: 0, ease:Linear.easeNone})) // draw word for 0.9
            .add(TweenMax.to('.sig.sig5', 0.9, {strokeDashoffset: 0, ease:Linear.easeNone})) // draw word for 0.9
            // .add(TweenMax.to($word2, 0.4, {strokeDashoffset: 0, ease:Linear.easeNone}))  // draw dot for 0.1
            .add(TweenMax.to(sigpath, 1, {stroke: "black", ease:Linear.easeNone}), 0);			// change color during the whole thing

        // build scene
        var scenesig = new ScrollMagic.Scene({triggerElement: ".home-misson", duration: 200, tweenChanges: true,triggerHook: 0.6,})
            .setTween(tweensig)
            //.addIndicators() // add indicators (requires plugin)
            .addTo(controller);



        //------------------sginature section-------------------END




    }

};

$(document).ready(function ()
{
    DBL.scrolls.init();
});

"use strict"

var DBL = (typeof DBL === 'object') ? DBL : {};

DBL.product = {
    VAR: {},
    init: function () {
        var _this = this;

        if(window.location.href.split('openreview').length > 1)
        {
            $('.new-review-form').show();
            setTimeout(function(){
                UTI.common.scrollTo('#stamped-main-widget',140,500);},500);
        }

        $('.pdp-main .gallery .image .gallery-big').slick({

            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: false,
            dots: false,
            asNavFor: '.thumbs .thumb-slick',
            arrows: false, adaptiveHeight: true,

            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        infinite: true,
                        dots: true
                    }
                }
            ]
        });
        /**/
        $('.thumbs .thumb-slick').slick({

            slidesToShow: 8, slidesToScroll: 1,
            // appendArrows: $(".slick-arrow-wrap"),
            prevArrow: '<div class="pd_prev"><svg version="1.1" s id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"\t viewBox="0 0 19 18" style="enable-background:new 0 0 19 18;" xml:space="preserve"><polygon style="fill:#707070;" class="st0" points="9.5,11.3 3.9,5.6 3,6.5 9.5,13 16,6.5 15.2,5.6 "/></svg></div>',
            nextArrow: '<div class="pd_next"><svg version="1.1" s id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"\t viewBox="0 0 19 18" style="enable-background:new 0 0 19 18;" xml:space="preserve"><polygon style="fill:#707070;" class="st0" points="9.5,11.3 3.9,5.6 3,6.5 9.5,13 16,6.5 15.2,5.6 "/></svg></div>',
            asNavFor: '.pdp-main .gallery .image .gallery-big',
            focusOnSelect: true, infinite: false, vertical: true
        });

        setTimeout(function(){
            if($('[this-variable-image]').length) $('[this-variable-image]').eq(0).click();
        },1000);


        if (UTI.isdesktop) {
            var $easyzoom = $('.easyzoom').easyZoom();
            var api = $easyzoom.data('easyZoom');
        }


        if (Modernizr.touchevents) {
            $('.zoomLoaderMessage').hide();
        }

        $(window).on('uti-width-changed', function () {
            setTimeout(function () {
                resetpage();
            }, 100);

        });
        setTimeout(function () {
            resetpage();
        }, 100);

        function resetpage() {
            var winhei = $(window).height();
            var winwid = $(window).width();

            if ($(window).width() < 1400) {
                var vidhei = ($('.video-video .you').width()) * (506 / 900);
                $('.video-video .you').height(vidhei);
            }


            if($('.pdpmp').length){

                var videocontainer = $('.pdpmp video');
                //var exwid = $(window).width()+3;
                // videocontainer.width(exwid);
                //videocontainer.css("left","-1px").css("position","relative");
                var newmp4 = $('.pdp-sou').attr('data-m');
                if (UTI.isdesktop)
                {
                    // videocontainer.height(exwid * (822/1920 ));
                    newmp4 = $('.pdp-sou').attr('data-d');
                }
                else
                {
                    //videocontainer.height(exwid * (768/720 ));
                }

                var videosource = $('.pdp-sou');

                videocontainer.get(0).pause();
                videosource.get(0).setAttribute('src', newmp4);
                videocontainer.get(0).load();
                //videocontainer.setAttribute('poster', newposter); //Changes video poster image
                videocontainer.get(0).play();


            }






        }

    },

    bundle: function () {

        var selectex = "Select a ";
        if ($(window).width() < 900) {
            selectex = "Select a ";
        }

        if (!window.location.search.includes("?variant=")) {
            $('.varient-drop .selector-wrapper').each(function () {
                var texts = $(this).find('.lable').text().split(' ');
                var lasttext = texts[texts.length - 1].toLowerCase();

                $(this).find('select').prepend($('<option/>', {
                    value: '0',
                    text: selectex + lasttext
                }));

            });

            $('.varient-drop select').val('0').change();
        }

        $('body').on('click', '.noption.cart-btn', function (e) {
            e.preventDefault();
            e.stopPropagation();
            $('.option-eroor').slideDown();
        });

        // hide 2n varient in starte set
        if($('.the-starter-set.pdp-main').length)
        {
            $('.the-starter-set.pdp-main .selector-wrapper').eq(1).find('select').val($('.the-starter-set.pdp-main .selector-wrapper').eq(1).find('select option').eq(1).val());
            $('.the-starter-set.pdp-main .selector-wrapper').eq(0).width('100%');
            $('.the-starter-set.pdp-main .selector-wrapper').eq(0).css("margin-right",'0px');
            $('.the-starter-set.pdp-main .selector-wrapper').eq(1).hide();
        }
        //forcat
        if($('.cat-no-wash-set.pdp-main').length)
        {
            $('.cat-no-wash-set .selector-wrapper').eq(0).find('select').val("1 Pack").trigger('change');;
            $('.cat-no-wash-set .selector-wrapper').hide();
        }

    },


    //for upselss
    upsells: function () {


        var upsellid = "";

        $('body').on('click', '.pdp-form .cart-btn .cart', function (e) {

            if ($('[data-product-select] option:selected').attr('data-upsell') && !$('.upsell-block.upselladded').length && !$('[name=selling_plan]').val() && $('#Quantity').val()=="1" ) {
                e.preventDefault();
                e.stopPropagation();
                $('body').append('<div class="siteloader"></div>');

                if($('[data-product-select] option:selected').text().includes("Default"))
                {
                    $('.upsell-block .ptext').html($('.pdp-title h1').text()+ ' <span>added to your cart</span>');
                }else
                {
                    $('.upsell-block .ptext').html($('.pdp-title h1').text()+":"+$('[data-product-select] option:selected').text() + ' <span>added to your cart</span>');
                }
                $('.upsell-block .image').html("<img src='"+$('[data-product-select] option:selected').data('varimage') + "' />");


                var productid = $('[data-product-select]').val();


                var datas = 'id=' + productid + "&quantity=1";

                upsellid = $('[data-product-select] option:selected').attr('data-upsellid');
                $('.upsell-item-var').hide();

                if($('body').find('.id-'+upsellid  ).length)
                {
                    $('.upsell-item').hide();
                    $('body').find('.id-'+upsellid).eq(0).show();
                }

                // Add to cart.
                $.ajax({
                    url: '/cart/add.js',
                    dataType: 'json',
                    type: 'post',
                    data: datas,
                    success: function (itemData) {
                        $('body').addClass('activeupsell');
                        $('.siteloader').remove();
                        PROJ.ajaxcart.updateCart();
                    },
                    error: function (XMLHttpRequest) {
                        $('body').remove('.siteloader');
                    }
                });
            }
        });

        $('body').on('click', '.up-wrap-out .cart-btn .cart', function (e) {


            e.preventDefault();
            e.stopPropagation();

            var productid = $('[data-product-select]').val();

            if(upsellid == "")
            {
                upsellid = $('[data-upsell-id]').data('upsell-id');
            }


            var datas = "updates[" + productid + "]=" + 0 + "&";
            datas += "updates[" +upsellid+ "]=" + 1 + "&";

            $('body').append('<div class="siteloader"></div>');


            // Add to cart.
            jQuery.ajax({
                type: 'POST',
                url: '/cart/update.js',
                data: datas,
                dataType: 'json',
                success: function () {
                    PROJ.ajaxcart.updateCart();
                    $('.siteloader').remove();
                    $('body').removeClass('activeupsell');
                    $('body,html').addClass('mini-cart');
                    setTimeout(function(){
                        $('body,html').addClass('mini-cart-ani');

                    },500);
                }
            });

        });

        $('body').on('click', '.up-wrap .closeit, .open-cart', function (e) {
            e.preventDefault();
            $('body').removeClass('activeupsell');
            $('body,html').addClass('mini-cart');
            setTimeout(function(){
                $('body,html').addClass('mini-cart-ani');

            },500);
        });

    }

};

"use strict"

var DBL = (typeof DBL === 'object') ? DBL : {};

DBL.faq = {
    VAR: {},
    init: function () {


        $('.faq-item-title').click(function (e) {

            e.preventDefault();

            $('.faq-item-wrap').slideUp();
            if ($(this).hasClass('active')) {
                $(this).removeClass('active');
            }
            else {
                $('.faq-item-title.active').removeClass('active');
                $(this).next().stop().slideDown();
                $(this).addClass('active');
                //window.location.hash =  $('.faq-item-title.active').attr('id');
            }

        });


        if(window.location.hash) {
            setTimeout(function(){
                jQuery(window.location.hash).trigger('click');
                UTI.common.scrollTo(window.location.hash,60,500);
            },500);
        }

        function checkPos(scrolls) {
            var pos = 0;
            $('.faq-section').each(function () {
                if ($(this).offset().top < (scrolls + 230)) {
                    pos = $(this).index();
                }
            });

            $('.faq-links .faq-l').removeClass('active');
            $('.faq-links .faq-l').eq(pos).addClass('active');


            if (scrolls > 100 && !$('body').hasClass('mobfaq')) {
                $('body').addClass('mobfaq');
            }
            else if ((scrolls < 100) && $('body').hasClass('mobfaq')) {
                $('body').removeClass('mobfaq');
            }




        }


    },

    changeScreen: function () {


    },


    navChange: function () {

    }
};


/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function() {
    var $newAddressForm = $('#AddressNewForm');

    if (!$newAddressForm.length) {
        return;
    }

    // Initialize observers on address selectors, defined in shopify_common.js
    if (Shopify) {
        new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
            hideElement: 'AddressProvinceContainerNew'
        });
    }

    // Initialize each edit form's country/province selector
    $('.address-country-option').each(function() {
        var formId = $(this).data('form-id');
        var countrySelector = 'AddressCountry_' + formId;
        var provinceSelector = 'AddressProvince_' + formId;
        var containerSelector = 'AddressProvinceContainer_' + formId;

        new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
            hideElement: containerSelector
        });
    });

    // Toggle new/edit address forms
    $('.address-new-toggle').on('click', function() {
        $newAddressForm.toggleClass('hide');
    });

    $('.address-edit-toggle').on('click', function() {
        var formId = $(this).data('form-id');
        $('#EditAddress_' + formId).toggleClass('hide');
    });

    $('.address-delete').on('click', function() {
        var $el = $(this);
        var formId = $el.data('form-id');
        var confirmMessage = $el.data('confirm-message');
        if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
            Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
        }
    });
})();

"use strict"

var UTI = (typeof UTI === 'object') ? UTI : {};
UTI.isdesktop = true;

UTI.common = {
    VAR: {
        navClosed: false,
        windowwidth: 0,
        windowheight: 0,
        $MainContent: $('#MainContent'),
        lastDeviceDesktop: true
    },
    init: function () {
        var _this = this;

        UTI.effect.init();

        //$("body").niceScroll({smoothscroll: true, scrollspeed: 100, mousescrollstep: 40});

        $(window).resize(function () {
            //use nav menu text to detect mobile and desktop
            if ((jQuery(window).width() > 768) && !UTI.isdesktop) {
                UTI.isdesktop = true;
                $(window).trigger('uti-device-changed');
            }
            else if ((jQuery(window).width() < 768) && UTI.isdesktop) {
                UTI.isdesktop = false;
                $(window).trigger('uti-device-changed');
            }
            _this.checkResize();
            changeback();
        });
        changeback();
        function changeback()
        {
            if ((jQuery(window).width() < 768 ))
            {
                $('[data-back-mob]').each(function(){
                    $(this).css("backgroundImage",'url("'+ $(this).attr('data-back-mob')+'")');
                });
            }else
            {
                $('[data-back-desk]').each(function(){
                    $(this).css("backgroundImage",'url("'+ $(this).attr('data-back-desk')+'")');
                });
            }

        }


        setTimeout(function () {
            $(window).trigger('uti-device-changed');
            $(window).trigger('uti-width-changed');

        }, 100);

        //common function to change all the image with the dievice change
        $(window).on('uti-device-changed', function () {

            if (UTI.isdesktop) {
                $('[data-deskimage]').each(function () {
                    $(this).attr('src', $(this).attr('data-deskimage'));
                });
            }
            else {
                $('[data-mobimage]').each(function () {
                    $(this).attr('src', $(this).attr('data-mobimage'));
                });
            }
        });

        window.addEventListener("scroll", scrolleffect);

        function scrolleffect(e)
        {


        }

        // commin + / - buttons
        $('body').on('click','.product-counts .plus',function(e){

            e.preventDefault();
            var inputs =  $(this).parent().find('input');
            var vals = $(this).parent().find('input').val();
            if(vals < parseInt(inputs.attr("max")))
            {
                vals++;
            }
            inputs.val(vals);
            $('.itemWrap-cart form').trigger('submit');
        });
        $('body').on('click','.product-counts .mins',function(e){

            e.preventDefault();
            var inputs =  $(this).parent().find('input');
            var vals = $(this).parent().find('input').val();
            var minval = 1;
            if($(this).hasClass('zero'))
            {
                minval = 0;
            }
            if(vals > minval)
            {
                vals--;
            }
            inputs.val(vals);
            $('.itemWrap-cart form').trigger('submit');

        });



        //scroll throtle
        var scrollpos = 0;
        var scrollTimeout;
        var throttle = 200;

        //check promo

        setTimeout(function(){
            $(window).trigger('scroll');
        },100);

        $(window).on('scroll', function () {
            if (!scrollTimeout) {
                scrollTimeout = setTimeout(function () {
                    var goindown = window.pageYOffset>scrollpos?true:false;
                    scrollpos = window.pageYOffset;
                    $(window).trigger('utiscroll', [window.pageYOffset, goindown]);
                    scrollTimeout = null;

                    window.pageYOffset > 300?$('body').addClass('scrolled'):$('body').removeClass('scrolled');
                    window.pageYOffset > 0?$('body').addClass('qscroll'):$('body').removeClass('qscroll');

                }, throttle);
            }
            //var goindown = window.pageYOffset>scrollpos?true:false;
            //scrollpos = window.pageYOffset;
            //$(window).trigger('utiscroll', [window.pageYOffset, goindown]);
        });

        // simple accordion for all, use ac-title

        $( '.ac-title:not(.active)').each(function(){

            if($(this).hasClass("mm"))
            {
                if(!UTI.isdesktop)
                {
                    $(this).next().css('display','none');
                }
            }
            else
            {
                $(this).next().css('display','none');
            }

        });

        $('body').on('click', '.ac-title', function (e) {

            e.preventDefault();
            e.stopPropagation();
            if ($(this).hasClass('active')) {
                $(this).next().removeClass('active');
                $(this).next().slideUp();
                $(this).find('i').attr('class', "fa fa-angle-down");
            }
            else {
                $(this).next().addClass('active');
                $(this).next().slideDown();
                $(this).find('i').attr('class', "fa fa-angle-up");
            }
            $(this).toggleClass('active');
            if($(this).hasClass('ac-single'))
            {
                $(this).parent().find('> .ac-title').next().stop().slideUp().removeClass('active');
                $(this).parent().find('> .ac-title').removeClass('active');
                $(this).next().addClass('active').stop().slideDown();
                $(this).addClass('active');

            }

        });

        //=============popup window for links with class popit-------------------------

        $('body').on('click', "[data-popit]", function (e) {
            e.preventDefault();
            e.stopPropagation();
            var link = $(this).attr('href') + " " + $(this).attr('data-popit');

            $('<div>').dialog({
                modal: true, draggable: false,
                open: function () {
                    $(this).load(link, function() {
                        // $(".tableWrap").mCustomScrollbar({
                        //    axis: "x" // horizontal scrollbar
                        // });
                    });

                },
                height: "100%",
                width: "100%"
            });
        });
        $('body').on('click', ".ui-widget-overlay", function (e) {
            $('.ui-dialog-titlebar-close').trigger('click');
        });

        //=============----------------------------

        //to run with the fix popup

        $('body').on('click','[data-fixpop]',function(e){
            e.preventDefault();
            $('.'+$(this).attr('data-fixpop')).addClass('active');
            $('body').append('<div class="fix-pop-back"></div>');
            setTimeout(function(){
                $('body').addClass('pop-open');
            },100);

        });


        $('body').on('click','.fix-popup .close,.fix-pop-back',function(e){
            e.preventDefault();
            $('.fix-popup').removeClass('active');
            $('body').removeClass('pop-open');
            $('.fix-pop-back').remove();

        });

        // play pause video

        $('video.click-play').click(function(e){
            $(this).toggleClass("play");
            if($(this).hasClass("play"))
            {
                $(this).get(0).play();
            }
            else
            {
                $(this).get(0).pause();
            }
        });







    },
    checkResize: function () {
        var _this = this;
        if (_this.VAR.$MainContent.width() !== _this.VAR.windowwidth || $(window).height() !== _this.VAR.windowheight) {
            _this.VAR.windowwidth = _this.VAR.$MainContent.width();
            _this.VAR.windowheight = $(window).height();
            $(window).trigger('uti-width-changed');





        }
        _this.VAR.windowwidth = _this.VAR.$MainContent.width();
        _this.VAR.windowheight = $(window).height();
    },



    // scroll to function
    scrollTo: function (targetElement, offset, duration) {
        var scrollAmount = 0;
        if (!isNaN(targetElement)) {
            scrollAmount = targetElement;
        } else {
            targetElement = targetElement instanceof jQuery ? targetElement : $(targetElement);
            offset = offset || 0;
            duration = duration || 200;
            scrollAmount = targetElement.offset().top - offset;
        }

        $('html, body').animate({
            scrollTop: scrollAmount
        }, duration);
    }




};

$(function () {



    if ((jQuery(window).width() > 749) && !UTI.isdesktop) {
        UTI.isdesktop = true;
        $(window).trigger('uti-device-changed');
    }
    else if ((jQuery(window).width() < 750) && UTI.isdesktop) {
        UTI.isdesktop = false;
        $(window).trigger('uti-device-changed');
    }
    UTI.common.init();
});

jQuery.cookie=function(b,j,m){if(typeof j!="undefined"){m=m||{};if(j===null){j="";m.expires=-1}var e="";if(m.expires&&(typeof m.expires=="number"||m.expires.toUTCString)){var f;if(typeof m.expires=="number"){f=new Date();f.setTime(f.getTime()+(m.expires*24*60*60*1000))}else{f=m.expires}e="; expires="+f.toUTCString()}var l=m.path?"; path="+(m.path):"";var g=m.domain?"; domain="+(m.domain):"";var a=m.secure?"; secure":"";document.cookie=[b,"=",encodeURIComponent(j),e,l,g,a].join("")}else{var d=null;if(document.cookie&&document.cookie!=""){var k=document.cookie.split(";");for(var h=0;h<k.length;h++){var c=jQuery.trim(k[h]);if(c.substring(0,b.length+1)==(b+"=")){d=decodeURIComponent(c.substring(b.length+1));break}}}return d}};
"use strict"

var DBL = (typeof DBL === 'object') ? DBL : {};

DBL.passw = {
    VAR: {},
    init: function () {

        $(window).on('resize', function () {
            resizepw();
        });

        $('.adddog').click(function(e){
            e.preventDefault();
            $('.cus.dog:not(.ons)').eq(0).addClass('ons');
            if(!$('.cus.dog:not(.ons)').length)
            {
                $('.adddog').hide();
            }

        });

        resizepw();

        function resizepw() {
            var he = $(window).height();
            var wi = $(window).width();

            $('.pass-back').height(he);
            $('.pass-back').width(wi);
        }


        $('.template-password').waitForImages(
            function () {
                setTimeout(function () {
                    resizepw();
                    playanimation();
                }, 100);
            });

        var img1 = $('.img1');
        var img2 = $('.img2');
        var img3 = $('.img3');

        function playanimation() {
            $('.template-password').removeClass('wait');

            setTimeout(function () {
                TweenMax.to(img1, 1, {bottom: "0%"});
            }, 200);
            setTimeout(function () {
                TweenMax.to(img2, 1, {bottom: "0%"});
            }, 400);
            setTimeout(function () {
                TweenMax.to(img3, 1, {bottom: "0%"});
            }, 200);

            setTimeout(function () {

                if (Modernizr.touchevents) {
                    window.ondevicemotion = function (event) {

                        var accX = Math.round(event.accelerationIncludingGravity.x * 10) / 10;
                        var accY = Math.round(event.accelerationIncludingGravity.y * 10) / 10;

                        var sca = accY;
                        if(sca > 8) sca = 8;
                        if(sca<0) sca = 0;
                        sca = 1.25 - (sca/32);


                        TweenMax.to(img3, 1, {
                            scale:sca, transformOrigin: "center bottom"
                        });
                    };


                } else {
                    $('body').on("mousemove", function (e) {
                        var x = e.clientX,
                            y = e.clientY;
                        var w = window.innerWidth / 2;
                        var h = window.innerHeight;

                        var l = ((w - x) / w);
                        var t = (1 - y / h);

                        TweenMax.to(img1, 1, {
                            bottom: (t * -6) + "%",
                            right: (l * 4) + "%"
                        });
                        TweenMax.to(img2, 1, {
                            bottom: ((t * 2) - 2) + "%",
                            right: ((l * 1) - 1) + "%"

                        });
                        /*
                        console.log(l);

                        img1.css('bottom',(t * -6) + "%");
                        img1.css('right',(l * 4)  + "%");

                        img2.css('bottom',((t * 2)-2) + "%");
                        img2.css('right',((l * 1)-1)  + "%");*/

                    });
                }
            }, 1400);

            if($('.thank2').length)
            {
                TweenMax.to($('.thank2'), 1, {opacity:0, repeat:-1, yoyo:true});
            }




        }


    }
};


jQuery(function () {
    // DBL.passw.init();
});


"use strict"

var UTI = (typeof UTI === 'object') ? UTI : {};

UTI.effect = {
    VAR: {
        dogbarking:false
    },
    init: function () {
        var _this = this;


        $('body').on('mouseenter','.homelogo',function(){
            UTI.effect.dogbark();
        });

        UTI.effect.dogbark();

    },
    dogbark: function () {

        if(UTI.effect.VAR.dogbarking)
        {
            return;
        }
        else
        {
            UTI.effect.VAR.dogbarking = true;
            setTimeout(function(){
                UTI.effect.VAR.dogbarking = false;
            },4000);
        }

        var _this = this;
        var logo = $('.homelogo svg');

        if($('.homelogo').hasClass('dog'))
        {
            var d = logo.find('path').eq(0);
            var o = logo.find('path').eq(1);
            var g = logo.find('path').eq(2);
            TweenMax.to(d, 0, {y: 0, rotation: 0,scale:1, transformOrigin: "center center"});
            TweenMax.to(g, 0, {y: 0, rotation: 0,scale:1, transformOrigin: "center center"});

            var tl = new TimelineMax().timeScale(3);
            tl.to(d,0.5,{rotation:20});

            tl.to(d,0.5,{y:-5,rotation:15,scale:1,transformOrigin: "center center"},1);
            tl.to(d,0.5,{y:3,rotation:10,transformOrigin: "center center"});
            tl.to(d,0.5,{y:-5,rotation:15,transformOrigin: "center center"});
            tl.to(d,0.5,{y:3,rotation:10,transformOrigin: "center center"});
            tl.to(d,0.5,{y:-5,rotation:15,transformOrigin: "center center"});
            tl.to(d,0.5,{y:-5,rotation:15,transformOrigin: "center center"});

            tl.to(g,0.5,{rotation:15, transformOrigin: "center center"});
            tl.to(g,0.5,{rotation:-15, transformOrigin: "center center"});
            tl.to(g,0.5,{rotation:15, transformOrigin: "center center"});
            tl.to(g,0.5,{rotation:-15, transformOrigin: "center center"});
            tl.to(g,0.5,{rotation:15, transformOrigin: "center center"});
            tl.to(g,0.5,{rotation:-15, transformOrigin: "center center"});
            tl.to(g,0.5,{rotation:7, transformOrigin: "center center"});
            tl.to(g,0.5,{rotation:0, transformOrigin: "center center"});

            tl.staggerTo(d,1,{rotation:0,y:0, transformOrigin: "center center"},6);
        }
        else
        {
            var logo = $('.homelogo svg');
            var d = logo.find('path').eq(0);
            var o = logo.find('path').eq(1);
            var g = logo.find('path').eq(2);
            var e = logo.find('path').eq(3);
            var c = logo.find('circle');

            TweenMax.to(d, 0, {y: 0, rotation: 0,scale:1, transformOrigin: "center center"});
            TweenMax.to(o, 0, {y: 0, rotation: 0,scale:1, transformOrigin: "center center"});
            TweenMax.to(g, 0, {y: 0, rotation: 0,scale:1, transformOrigin: "center center"});
            TweenMax.to(e, 0, {y: 10,x:0, rotation: -20,scale:1,opacity:0, transformOrigin: "center bottom"});
            TweenMax.to(c, 0, {y: 0,scale:1,opacity:0, transformOrigin: "center center"});

            var tl = new TimelineMax().timeScale(3);
            tl.to(d,1.5,{rotation:24,y:-5});
            tl.to(o,1.5,{y:-1.5,rotation:2},'-=1');
            tl.to(e,1.5,{opacity:1,y:1,rotation:0},'-=1');
            tl.to(c,1,{opacity:1,y:-2},'-=0');
            tl.to(e,1,{rotation:6,y:1,x:1},'+=1.5');
            tl.to(e,1,{rotation:2,y:1,x:0},'+=0.5');
            tl.to(c,1,{y:-3,x:-1},'-=0.5');
            tl.to(c,0.5,{opacity:0},'-=0');
            tl.to(c,0.5,{opacity:1},'+=0');

            tl.to(d,1.5,{rotation:0,y:-0},'+=2');
            tl.to(o,1.5,{y:0,rotation:0},'-=1.5');
            tl.to(e,1.5,{opacity:0,y:10,rotation:-12},'-=1.5');
            tl.to(c,1.5,{opacity:0,y:3},'-=1.5');
        }


    }

};


$(document).ready(function () {


    $('body').on('click', '.main-nav-wrap a.line:not(.link)', function (e) {

        e.preventDefault();
        $('body').addClass("nav-int");
        setTimeout(function(){
            $('body').addClass('naved scrolled');
        },100);

        if( !$(this).hasClass('active'))
        {
            $('.main-nav-wrap a.line.active').removeClass('active');
            $(this).addClass('active');
            $('.left-sub').removeClass('active');
            $('.left-sub').eq($(this).index()-1).addClass('active');
        }

    });

    if($('.notibar .box2').length)
    {
        setInterval(function(){
            // $('.notibar').addClass('hides');
            setTimeout(function(){
                $('.box1,.box2').toggle();
                $('.notibar').removeClass('hides');
            },250);
        },4000);
    }

    $('.cselect').click(function(){
        $(this).toggleClass('mobclick');
    });

    $('body').on('click', '.nav-close', function (e) {

        e.preventDefault();
        UTI.effect.dogbark();
        $('body').removeClass("naved");

        if( $(document).scrollTop() < 300)
        {
            $('body').removeClass('scrolled');
        }
        setTimeout(function(){
            $('body').removeClass('nav-int');
        },500);

        $('.left-sub').removeClass('active');
        $('.main-nav-wrap a.line.active').removeClass('active');

    });

    $('body').on('click', '.mob-burger', function (e) {

        e.preventDefault();
        $('.main-nav-wrap a.line').eq(0).trigger('click');

    });

    // notifcation bar
    var cookienot = "hidenoti3";

    if($('[data-cookie].notibar').attr('data-cookie'))
    {
        cookienot = $('[data-cookie].notibar').attr('data-cookie');
    }

    // if()
    var notification = false;
    if($('body.notifi-pre').length)
    {
        notification = true;
    }
    if(jQuery.cookie(cookienot))
    {
        notification = false;
    }
    if(notification)
    {
        $('body').addClass('notifi');
    }


    $('.notibar .close').click(function(e){

        e.preventDefault();
        $('body').removeClass('notifi');
        jQuery.cookie(cookienot,'true');

    });


});

"use strict"

var PROJ = (typeof PROJ === 'object') ? PROJ : {};

PROJ.ajaxcart = {
    VAR: {},

    init: function () {
        var _this = this;
        _this.updateCart();
        _this.giftwrap();

        $('body').on('click', '.nav-close-cart,.minicart-back', function (e) {
            e.preventDefault();
            $('body,html').removeClass('mini-cart');
            setTimeout(function(){
                $('body,html').removeClass('mini-cart-ani');
            },500);
        });

        $('body').on('click', '.mob-cart a, .cart-desk', function (e) {
            e.preventDefault();
            UTI.effect.dogbark();
            $('body,html').addClass('mini-cart');
            setTimeout(function(){
                $('body,html').addClass('mini-cart-ani');
            },500);
        });

        //activate free gift with chkecnbox

        $('body').on('change', '#fgifts', function (e) {
            if(this.checked) {
                $('.free-items-box .dum').hide();
                $('.free-items-box .org').show();
            }else
            {
                $('.free-items-box .dum').show();
                $('.free-items-box .org').hide();
            }
        });
        //2024
        $('body').on('click', '[data-protection-id]', function (e) {
            e.preventDefault();
            if($(this).hasClass('active'))
            {
                sessionStorage.setItem('noprotection',true);
                _this.updateItem($(this).attr('data-protection-id'), 0);
            }else
            {
                sessionStorage.clear('noprotection');
                _this.addItem($(this).attr('data-protection-id'));
            }
        });

        $('body').on('click','.quick-pay-btn', function (e) {
            e.preventDefault();
            $('#mini-cart').toggleClass('quickpay');
        });

        $('body').on('change', '.quick-buy select', function (e) {
            e.preventDefault();
            var varid = $(this).val();
            $(this).parents('.cross-slide').find('.quick-buy a').attr('data-directadd',varid);
            $(this).parents('.cross-slide').find('.money').text('Only '+$(this).find('option:selected').attr('data-varprice') );
        });

        //quick add
        $('body').on('change', '.col-quick-buy select', function (e) {
            e.preventDefault();
            var varid = $(this).val();
            $(this).parents('.col-quick-buy').find('[data-directadd]').attr('data-directadd',varid);
        });



        $('body').on('click', '[data-directadd]', function (e) {
            e.preventDefault();
            _this.addItem($(this).attr('data-directadd'));
        });

        $('body').on('click', '.qty-step-btn', function (e) {
            e.preventDefault();
            var par = $(this).parents('.incart');
            var qty = par.attr('data-count');
            if ($(this).find('.icon-minus').length) {
                qty--;
                if (qty < 0) qty = 0;
            }
            else {
                qty++;
            }
            _this.updateItem(par.attr('data-proid'), qty);

            setTimeout(function(){
                if($('body').hasClass('template-cart'))
                {
                    location.reload(true);
                }
            },500);


        });

        $('body').on('click', '.incart .remove', function (e) {
            e.preventDefault();
            var par = $(this).parents('.incart');
            var qty = 0;
            _this.updateItem(par.attr('data-proid'), qty);
        });


        // removing upsell
        $('body').on('click', '.remove.removeupsell', function (e) {
            e.preventDefault();
            $('#mini-cart').addClass("hide-upsell");
            jQuery.cookie("hideupsells","true");
        });

        $('body').on('click', '.show-upsell', function (e) {
            e.preventDefault();
            $('#mini-cart').removeClass("hide-upsell");
            jQuery.cookie("hideupsells","false");
        });

        $('body').on('click', '[data-varid]', function (e) {
            e.preventDefault();
            var varid = $(this).attr('data-varid');
            $(this).parents('.cross-slide').find('.quick-buy a').attr('data-directadd',varid);
            $(this).parents('.cross-slide').find('.money').text($(this).attr('data-var-price'));
            $(this).parents('.cross-slide').find('[data-varid]').removeClass('active');
            $(this).addClass('active');
        });



        $('body').on('click', '.choose .no', function (e) {
            e.preventDefault();
            $('.sure-nogift').removeClass('active');
            $('body').addClass('hili');
            $('.mini-body').animate({scrollTop: 0}, 200);
            setTimeout(function(){
                setTimeout(function(){
                    $('body').removeClass('hili');
                },1500);
            },500);
        });
        // suplimant warnings
        $('body').on('click', '.pdp-warning .exit,.pdp-warning .background', function (e) {
            e.preventDefault();
            $('body,html').removeClass("active-warning-ani");
            setTimeout(function(){$('body,html').removeClass("active-warning");},500);
        });

        $('body').on('click', '.pdp-warning .confirm', function (e) {
            e.preventDefault();
            $('body,html').removeClass("active-warning-ani");
            setTimeout(function(){$('body,html').removeClass("active-warning");},500);
            $('form.warning').removeClass('warning');
            $('form[action="/cart/add"]').trigger('submit');
        });

        $('body').on('click', '.pdp-warning .com-check', function (e) {
            e.preventDefault();
            $(this).toggleClass('active');
            $('.pdp-warning .confirm').toggleClass('active');
        });

        $('body').on('submit','#minicheckout', function (e) {
            if( $('.sure-nogift').length)
            {
                e.preventDefault();
                $('.sure-nogift').addClass('active');
            }
        });

        $('form[action="/cart/add"]').on('submit', (function (e) {
            //$('body').on('submit', 'form[action="/cart/add"]', (function (e) {
            e.preventDefault();

            if($(this).hasClass('warning'))
            {
                $('body,html').addClass("active-warning");
                setTimeout(function(){$('body,html').addClass("active-warning-ani");},100);
                return false;
            }

            var $addToCartForm = $(this);
            var $addToCartBtn = $('.cart-btn button');
            $('#mini-cart').addClass('loading');

            $addToCartBtn.addClass('disabled').prop('disabled', true);
            $('body,html').addClass('mini-cart');
            setTimeout(function(){
                $('body,html').addClass('mini-cart-ani');

            },500);

            $.ajax({
                url: '/cart/add.js',
                dataType: 'json',
                type: 'post',
                data: $addToCartForm.serialize(),
                success: function (itemData) {
                    $addToCartBtn.removeClass('disabled').prop('disabled', false);
                    _this.updateCart();
                    $('body').removeClass('promo-hidenav');
                    if($('#autoaddvarid').length)
                    {
                        //not with upsell items
                        $('#autoaddvarid').trigger('click');
                        $('#autoaddvarid,.autoaddvarid').remove();
                    }
                },
                error: function (XMLHttpRequest) {
                    _this.updateCart();
                    alert(XMLHttpRequest)

                }
            });
            return false;

        }));

        $(window).resize(function () {
            //use nav menu text to detect mobile and desktop
            if ((jQuery(window).width() > 768) && !UTI.isdesktop) {
                UTI.isdesktop = true;
                $(window).trigger('uti-device-changed');
            }
            else if ((jQuery(window).width() < 768) && UTI.isdesktop) {
                UTI.isdesktop = false;
                $(window).trigger('uti-device-changed');
            }
            _this.resizecart();
        });
        $(window).resize(function () {
            PROJ.ajaxcart.resizecart();
        });
        setTimeout(function(){
            PROJ.ajaxcart.resizecart();
        },1000);

        if (window.location.href.indexOf("minicart=true") > -1) {
            $('body,html').addClass('mini-cart');
            setTimeout(function(){
                $('body,html').addClass('mini-cart-ani');
            },500);
        }


    },resizecart:function(){
        // var maxh = $(window).height()-80;
        // $('.ajax_place').css('max-height',maxh+"px");
        // $('#mini-cart .mini-body').css('max-height','calc(100vh - '+(120+$('.checkout-se').height() + $('.cart-name').height() + $('.sell-note').height())+'px)');
    },

    updateCart: function () {
        var _this = this;
        var pet = "/cart?view=mini";
        if($('body').hasClass('body-cat'))
        {
            pet = "/cart?view=minicat";
        }
        $('body,html').removeClass('mini-cart-ani');

        $.get("/cart?view=mini", function (data) {

            // $('.offer-line.cart p').html($(data).find('.free-ship').html());

            // var counti = "";
            // if ($('.mini-header').attr('data-icount') != "0") {
            //     counti = $('.mini-header').attr('data-icount');
            // }

            // $('.cart-count').text(counti);
            // counti==0?$('.cart-count').hide():$('.cart-count').show();

            ///
            $('#mini-cart .ajax_place').html($(data));
            var counti = $('[data-icount]').attr('data-icount');
            if(withprotection) counti -= 1;

            counti==0? $('.cart-count').text(''): $('.cart-count').text(counti);

        }).done(function (cart) {

            $('#mini-cart').removeClass('loading');
            _this.animateCart();


        });
    },

    animateCart: function () {
        // to update and animate mini cart with total price
        var _this = this;

        $('.ns-target-gift').appendTo('.target-gifts');

        var locks = $('.target-locks .target');
        var progess_bar_val = $('.ns-progress').data('progress'); // total price

        var gifts = $('.ns-target-gift');
        for (var i = 0; i < gifts.length; i++) {
            var target = gifts.eq(i);
            if(progess_bar_val >= target.attr('data-gift-target') && target.hasClass('giftfalse') && target.hasClass('noappgift'))
            {
                _this.addItem(target.attr('data-gift-id'));
                return;
            }else if (progess_bar_val < target.attr('data-gift-target') && target.hasClass('gifttrue')  && target.hasClass('noappgift'))
            {
                _this.updateItem(target.attr('data-gift-id'),0);
                return;
            }else if (target.hasClass('multigift'))
            {
                _this.updateItem(target.attr('data-gift-id'),1);
                return;
            }
        }

        if($('[data-remove-other-free]').length)
        {
            _this.updateItem($('[data-remove-other-free]').eq(0).attr('data-remove-other-free'),0);
        }

        var gap = 100 / (locks.length - 1);
        var current_target;
        var next_target;
        var last_target = locks.eq(locks.length - 1);

        // cartAnimationOnce = setTimeout(function(){},1500);
        locks.each(function(i){
            if(progess_bar_val >= $(this).data('target'))
            {
                var element = $(this);
                current_target = $(this);
                next_target = locks.eq(i+1);
                setTimeout(function() {
                    element.addClass("active");
                }, 300 * i);
            }
        });

        if(next_target) {
            if (next_target.length) {
                var extraval = (progess_bar_val - current_target.data('target')) / (next_target.data('target') - current_target.data('target'));
                var barwidth = (current_target.index() * gap) + (gap * extraval);
                $('.ns-progress-fill').width(barwidth + "%");
            } else {
                $('.ns-progress-fill').width("100%");
            }
        }
        //quickpay buttons
        var quickpay = JSON.parse($('[wallet-configs]').attr('wallet-configs'));
        for (var s = 0; s < quickpay.length; s++) {
            $('#mini-cart').addClass(quickpay[s].name);
        }



        $('body,html').addClass('mini-cart-ani');





    },

    addItem: function (id) {
        var _this = this;
        $('#mini-cart').addClass('loading');
        $('body,html').addClass('mini-cart');

        $.ajax({
            type: "POST",
            url: "/cart/add.js",
            data: "quantity=" + 1 + "&id=" + id,
            dataType: "json",
            success: function (t) {
                _this.updateCart();
            },
            error: function (t, r) {
                _this.updateCart();
            }
        });
    }, updateItem: function (id, le) {
        var _this = this;
        $('#mini-cart').addClass('loading');
        UTI.effect.dogbark();

        $.ajax({
            type: "POST",
            url: "/cart/change.js",
            data: "quantity=" + le + "&id=" + id,
            dataType: "json",
            success: function (t) {
                _this.updateCart();
            },
            error: function (t, r) {
                _this.updateCart();
            }
        });
    },

    giftwrap: function () {
        var _this = this;
        $('body').on('keyup','#gift-note', function (e) {
            var count = $(this).val().length;
            var max = $(this).attr('maxlength');
            $(this).next().html("<strong>"+(max - count) +"</strong>"+ " Characters Remaining");
        });

        $('body').on('click','.gift-wrap-panel .all-close-cart, .gift-wrap-panel .cancel', function (e) {
            $('.gift-wrap-panel ').removeClass('active');
        });
        $('body').on('click','.gift-wrap-box .propose', function (e) {
            if($('.gift-wrap-wrap').hasClass('activegift'))
            {
                var gid = $('[data-gift-wrap-id]').attr('data-gift-wrap-id');
                $('#mini-cart').addClass('loading');
                $.ajax({
                    type: "POST",
                    url: "/cart/update.js",
                    data: "updates["+gid+"]=0&attributes[gift-note]="+encodeURIComponent(''),
                    dataType: "json",
                    success: function (t) {
                        _this.updateCart();
                    },
                    error: function (t, r) {
                        _this.updateCart();
                    }
                });
            }else
            {
                $('.gift-wrap-panel ').addClass('active');
            }
        });
        $('body').on('click','.gift-wrap-box .edit', function (e) {
            $('.gift-wrap-panel ').addClass('active');
        });
        $('body').on('click','[data-gift-wrap-id]', function (e) {
            e.preventDefault();
            var gid = $(this).attr('data-gift-wrap-id');
            $('#mini-cart').addClass('loading');
            if($('.gift-wrap-wrap').hasClass('activegift'))
            {
                $.ajax({
                    type: "POST",
                    url: "/cart/update.js",
                    data: "attributes[gift-note]="+encodeURIComponent($('#gift-note').val()),
                    dataType: "json",
                    success: function (t) {
                        _this.updateCart();
                    },
                    error: function (t, r) {
                        _this.updateCart();
                    }
                });
            }else
            {
                $.ajax({
                    type: "POST",
                    url: "/cart/update.js",
                    data: "updates["+gid+"]=1&attributes[gift-note]="+encodeURIComponent($('#gift-note').val()),
                    dataType: "json",
                    success: function (t) {
                        _this.updateCart();
                    },
                    error: function (t, r) {
                        _this.updateCart();
                    }
                });
            }

        });


    }


};


$(document).ready(function () {
    PROJ.ajaxcart.init();

    var $addToCartBtn = $('.cart-btn button');


    $('body').on('submits', 'form[action="/cart/add"]', (function (e) {

        // $('form[action="/cart/add"]').submit(function(e) {
        e.preventDefault();
        var $addToCartForm = $(this);

        $addToCartBtn.addClass('disabled').prop('disabled', true);
        // Add to cart.
        $.ajax({
            url: '/cart/add.js',
            dataType: 'json',
            type: 'post',
            data: $addToCartForm.serialize(),
            success: function (itemData) {
                $addToCartBtn.removeClass('disabled').prop('disabled', false);

                $('body').append('<div class="cart-added"><div class="box"><a class="close" href="#"></a><h2>IT\'S IN THE BAG</h2><a class="cont" href="#">Continue Shopping</a><a href="/cart" class="checkout"><span>CHECKOUT OUT NOW</span></a></div></div>');
                setTimeout(function () {
                    $('.cart-added').addClass('open');
                }, 100);


                updateicon();

            },
            error: function (XMLHttpRequest) {
                console.log('product adder');

            }
        });
        return false;


    }));

    $('body').on('click','[data-scroll-to]',function(e){
        e.preventDefault();
        $('html, body').animate({ scrollTop: $($(this).attr('href')).offset().top - 80}, 1000);
    })


    function updateicon() {

    }

    $('body').on('click', '.cart-added .close,.cart-added .cont', function (e) {
        e.preventDefault();
        $('.cart-added').removeClass('open');
        setTimeout(function () {
            $('.cart-added').remove();
        }, 1000);
    });

    //common blog
    if (window.location.href.indexOf("from=") > -1) {
        var coun = '';
        if(window.location.href.indexOf("from=us") > -1)
        {
            var coun = 'us';
        }else if(window.location.href.indexOf("from=uk") > -1)
        {
            var coun = 'uk';
        }
        $('body').addClass('blog-only');
        $('.article .alink, .hero-cta').each(function(){
            $(this).attr('href',$(this).attr('href')+"?from="+coun);
        });
        $('.homelogo a').attr('href', "https://"+coun+".dogbydrlisa.com/");
        $('.blog-cross a').each(function(){
            $(this).attr('href',"https://"+coun+".dogbydrlisa.com"+$(this).attr('href'));
        });
    }

});
